// @flow

import type { PaymentOptionTEF, TefBankList } from '@tectonics/prs/incoming-payment/payment-option';

export function getTefBankList(paymentOption: PaymentOptionTEF): TefBankList {
  return paymentOption['bank_list'];
}
